import React, { Fragment } from "react";
import Doughnut from "../GraphViews/Doughnut";
import Spinner from "../Spinner";

const MultiGlobalKpiView = props => {
  const dataMultiDoughnut = props.data || {};

  const dataMulti = Object.keys(dataMultiDoughnut).map(elementName => {
    const elementData = dataMultiDoughnut[elementName].data || [];
    const indicator = dataMultiDoughnut[elementName].indicator || 0;
    const percentagesArray = elementData.map(data => data.v);
    const newestPercentage = indicator;
    /*percentagesArray.length > 0
				? percentagesArray[percentagesArray.length - 1]
				: 0;*/
    const oldestPercentage = percentagesArray.length > 0 ? percentagesArray[0] : 0;
    return {
      elementName,
      newestPercentage: newestPercentage,
      oldestPercentage: oldestPercentage
    };
  });
  const kpi = props.kpi || {};
  return (
    <Fragment>
      <h2 className="p-page-subtitle p-txt-center">{props.title}</h2>
      <div className="p-al-c-center" style={{ position: "relative" }}>
        {props.loading ? <Spinner style={{ top: 100 }} /> : null}
        {/* {props.title} */}
        {!props.loading &&
          dataMulti.map((data, index) => {
            const flexDirection = index % 2 === 0 ? "row" : "row-reverse";
            const trend = Math.sign(data.newestPercentage - data.oldestPercentage);
            const iconClass = trend === 0 ? "icon-equal" : trend === -1 ? "icon-arrow-down" : "icon-arrow-up";
            return (
              <div key={index} className="p-al-r-full-center" style={{ flexDirection }}>
                <div className="p-w-1-2 p-txt-center" style={{ fontSize: "15px", padding: 20 }}>
                  {data.elementName}
                </div>
                {!kpi.format || kpi.format === "Pourcentage" || kpi.format_input === "percentage" ? (
                  <div className="p-w-1-2">
                    <Doughnut
                      newestPercentage={data.newestPercentage}
                      oldestPercentage={data.oldestPercentage}
                      kpi={kpi}
                      size="small"
                    />
                  </div>
                ) : (
                  <div className="p-w-1-2">
                    <Doughnut
                      newestPercentage={data.newestPercentage}
                      oldestPercentage={data.oldestPercentage}
                      kpi={kpi}
                      size="small"
                      full={true}
                    />
                  </div>
                  // <div className="p-al-r-full-center p-w-2-3 p-pdg-full">
                  // 	<div>
                  // 		<div
                  // 			className="p-txt-center"
                  // 			style={{
                  // 				fontSize: "4vh",
                  // 				fontWeight: "bold",
                  // 				marginTop: "5%",
                  // 			}}
                  // 		>
                  // 			<CountUp
                  // 				start={0}
                  // 				end={data.newestPercentage}
                  // 				duration={3}
                  // 				separator=" "
                  // 				style={{
                  // 					fontSize: "4vh",
                  // 					fontWeight: "bold",
                  // 					marginTop: "5%",
                  // 				}}
                  // 			/>
                  // 			{` ${StatsUtils.getKpiUnit(kpi)}`}
                  // 			<div
                  // 				className={iconClass}
                  // 				style={{ fontSize: "4vh", marginTop: "12%" }}
                  // 			/>
                  // 		</div>
                  // 	</div>
                  // </div>
                )}
              </div>
            );
          })}
      </div>
    </Fragment>
  );
};

export default MultiGlobalKpiView;



// WEBPACK FOOTER //
// src/modules/stats/components/DashboardViews/MultiGlobalKpiView.js